// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import { get } from 'crm_data/api/ImmutableAPI';
export const fetchV1Engagement = ({
  engagementId
}) => get(`engagements/v1/engagements/${engagementId}`);